import React, { useEffect, useState } from "react";
import { MdModeEditOutline, MdDelete, MdVisibility, MdReply, MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Card from "components/card";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getJobsApi, addJobApi, deleteJobApi } from "Services/allApi";
import { updateJobApi } from "Services/allApi";
import JobDetail from "./components/JobDetail";
import JobResponse from "./components/ResponseJob";
const JobPostings = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [viewType, setViewType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [jobToEdit, setJobToEdit] = useState(null);
  const [newJob, setNewJob] = useState({
    title: "",
    location: "",
    job_type: "Full-time",
    salary: "",
    description: "",
    application_deadline: "",
    is_active: true,
  });

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const response = await getJobsApi();
      if (response && !response.error) {
        setJobs(response.data);
      } else {
        toast.error("Failed to fetch job postings!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
    setLoading(false);
  };

  const validateJobFields = (job) => {
    return (
      job.title.trim() !== "" &&
      job.location.trim() !== "" &&
      job.salary.trim() !== "" &&
      job.description.trim() !== "" &&
      job.application_deadline.trim() !== ""
    );
  };


  const handleEditClick = (job) => {
    setJobToEdit(job);
    setNewJob({
      id: job.id,
      title: job.title,
      location: job.location,
      job_type: job.job_type,
      salary: job.salary,
      description: job.description,
      application_deadline: job.application_deadline,
      is_active: job.is_active,
    });
    setModalOpen(true);
  };

  const handleAddJob = async () => {
    if (!validateJobFields(newJob)) {
      toast.error("Please fill in all fields!");
      return;
    }
    try {
      const response = await addJobApi(newJob);
      if (response && !response.error) {
        toast.success("Job added successfully!");
        setModalOpen(false);
        setNewJob({
          title: "",
          location: "",
          job_type: "Full-time",
          salary: "",
          description: "",
          application_deadline: "",
          is_active: true,
        });
        fetchJobs();
      } else {
        toast.error("Failed to add job!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
  };

  const handleUpdateJob = async () => {
    if (!validateJobFields(newJob)) {
      toast.error("Please fill in all fields!");
      return;
    }
    try {
      const response = await updateJobApi(newJob.id, newJob);
      if (response && !response.error) {
        toast.success("Job updated successfully!");
        setModalOpen(false);
        setNewJob({
          title: "",
          location: "",
          job_type: "Full-time",
          salary: "",
          description: "",
          application_deadline: "",
          is_active: true,
        });
        fetchJobs();
      } else {
        toast.error("Failed to update job!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
  };
  const handleOpenModal = () => {
    setJobToEdit(null);
    setNewJob({
      title: "",
      location: "",
      job_type: "Full-time",
      salary: "",
      description: "",
      application_deadline: "",
      is_active: true,
    });
    setModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    setJobToDelete(id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (jobToDelete) {
      try {
        const response = await deleteJobApi(jobToDelete);
        if (response && !response.error) {
          toast.success("Job deleted successfully!");
          fetchJobs();
        } else {
          toast.error("Failed to delete job!");
        }
      } catch (error) {
        toast.error("An unexpected error occurred!");
      }
      setDeleteModalOpen(false);
      setJobToDelete(null);
    }
  };


  // Handle viewing job details
  const handleViewJob = (job) => {
    setSelectedJob(job);
    setViewType("detail");
  };

  // Handle viewing job responses
  const handleReplyJob = (job) => {
    setSelectedJob(job);
    setViewType("response");
  };

  // Close job detail or response view
  const handleCloseView = () => {
    setSelectedJob(null);
    setViewType("");
  };
  return (
    <>
      <Card extra={"w-full p-4 h-full"}>
        {selectedJob ? (
          // If a job is selected, show Job Details or Responses only
          <div className="p-4 bg-white rounded-lg shadow-md dark:bg-[#0b14374d] dark:text-white ">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-navy-700 dark:text-white">
                {viewType === "detail" ? "Job Details" : "Job Responses"}
              </h3>
              <MdClose className="cursor-pointer text-red-500" onClick={handleCloseView} size={23} />
            </div>

            {viewType === "detail" ? (
              <JobDetail job={selectedJob} />
            ) : (
              <JobResponse job={selectedJob} />
            )}
          </div>
        ) : (
          // If no job is selected, show job postings list
          <>
            <div className="mb-8 w-full flex justify-between items-center ">
              <h4 className="text-xl font-bold text-navy-700 dark:text-white">Job Postings</h4>
              <button
                onClick={handleOpenModal}
                className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-700"
              >
                Add Job
              </button>
            </div>

            {loading ? (
              <p className="text-center text-purple-800">Loading job postings...</p>
            ) : jobs.length > 0 ? (
              jobs.map((job) => (
                <div
                  key={job.id}
                  className="mb-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-md  dark:bg-gray-800 dark:text-white"
                >
                  <div className="flex flex-col">
                    <p className="text-base font-medium text-navy-700 dark:text-white">{job.title}</p>
                    <p className="text-sm text-gray-600">Location: {job.location}</p>
                    <p className="text-sm text-gray-600">Job Type: {job.job_type}</p>
                    <p className="text-sm text-gray-600">Salary: {job.salary}</p>
                    <p className="text-sm text-gray-600">Deadline: {job.application_deadline}</p>
                    <p className={`text-sm font-semibold ${job.is_active ? "text-green-500" : "text-red-500"}`}>
                      {job.is_active ? "Active" : "Inactive"}
                    </p>
                  </div>

                  <div className="flex space-x-4">
                    <MdReply
                      onClick={() => handleReplyJob(job)}
                      className="text-purple-500 hover:text-purple-800 cursor-pointer"
                      size={23}
                    />
                    <MdVisibility
                      onClick={() => handleViewJob(job)}
                      className="text-green-500 hover:text-green-800 cursor-pointer"
                      size={23}
                    />
                    <MdModeEditOutline
                      onClick={() => handleEditClick(job)}
                      className="text-yellow-500 hover:text-yellow-800 cursor-pointer"
                      size={23}
                    />
                    <MdDelete
                      onClick={() => handleDeleteClick(job.id)}
                      className="text-red-500 hover:text-red-800 cursor-pointer"
                      size={23}
                    />
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-purple-800">No job postings available.</p>
            )}
          </>
        )}
      </Card>
      {/* Add/Edit Job Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg w-1/2 dark:bg-gray-800 dark:text-white">
            <h2 className="text-lg font-bold mb-4">{jobToEdit ? "Edit Job" : "Add New Job"}</h2>
            <input type="text" placeholder="Job Title" className="w-full p-2 border rounded mb-2  dark:bg-gray-800 dark:text-white" value={newJob.title} onChange={(e) => setNewJob({ ...newJob, title: e.target.value })} />
            <input type="text" placeholder="Location" className="w-full p-2 border rounded mb-2  dark:bg-gray-800 dark:text-white" value={newJob.location} onChange={(e) => setNewJob({ ...newJob, location: e.target.value })} />
            <select className="w-full p-2 border rounded mb-2  dark:bg-gray-800 dark:text-white " value={newJob.job_type} onChange={(e) => setNewJob({ ...newJob, job_type: e.target.value })}>
              <option value="Full-time">Full-time</option>
              <option value="Part-time">Part-time</option>
              {/* <option value="Remote">Remote</option> */}
            </select>
            <input type="number" placeholder="Salary" className="w-full p-2 border rounded mb-2  dark:bg-gray-800 dark:text-white" value={newJob.salary} onChange={(e) => setNewJob({ ...newJob, salary: e.target.value })} />
            <textarea placeholder="Description" className="w-full p-2 border rounded mb-2  dark:bg-gray-800 dark:text-white" value={newJob.description} onChange={(e) => setNewJob({ ...newJob, description: e.target.value })} />
            <input type="date" className="w-full p-2 border rounded mb-2  dark:bg-gray-800 dark:text-white" value={newJob.application_deadline} onChange={(e) => setNewJob({ ...newJob, application_deadline: e.target.value })} />
            <select className="w-full p-2 border rounded mb-4  dark:bg-gray-800 dark:text-white" value={newJob.is_active.toString()} onChange={(e) => setNewJob({ ...newJob, is_active: e.target.value === "true" })}>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>

            <div className="flex justify-between">
              <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={() => setModalOpen(false)}>Cancel</button>
              <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={jobToEdit ? handleUpdateJob : handleAddJob}>{jobToEdit ? "Update" : "Submit"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 dark:bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-96 text-center dark:bg-gray-800 dark:text-white">
            <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
            <p className="mb-4">Are you sure you want to delete this job?</p>
            <div className="flex justify-center space-x-4">
              <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={() => setDeleteModalOpen(false)}>Cancel</button>
              <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={confirmDelete}>Delete</button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </>
  );
};

export default JobPostings;
